// extracted by mini-css-extract-plugin
export default {"fs":"_7204d11243 dd8fc7d962"};